/**
 * Create carousel with swiper.js
 */
import breakpointDefs from './lib/breakpoints.json'

export default class Carousel {
  /**
   * @param {Object} Swiper - Swiper library
   */
  constructor(container, Swiper, Pagination) {
    this.Swiper = Swiper
    this._register(container, Pagination)
  }

  _register(container, Pagination) {
    const paginationEl = container.getElementsByClassName('carousel__pagination')[0]

    const swiper = new this.Swiper(container, {
      loop: true,
      spaceBetween: 60,
      centeredSlides: true,
      preloadImages: true,
      slidesPerView: 'auto',

      modules: [ Pagination ],

      breakpoints: {
        [ breakpointDefs.xsmall ]: {
          spaceBetween: 20,
          disabled: true
        },
        [ breakpointDefs.medium ]: {
          spaceBetween: 40
        },
        [ breakpointDefs.large ]: {
          spaceBetween: 60
        },
      },

      pagination: {
        el: paginationEl,
        bulletClass: 'carousel__pagination-item',
        bulletActiveClass: 'active',
        clickable: true
      },

      on: {
        breakpoint: ( swiper, params ) => {
          params.disabled ? swiper.disable() : swiper.enable()
        }
      }
    })
  }
}